<section class="demands-panel" aria-label="Demand list">
  <div class="table-toolbar">
    <label class="search-control">
      <img src="assets/demands/search.svg" alt="" />
      <input
        type="search"
        aria-label="Search by application name or assignee name"
        placeholder="Search by application name or assignee name..."
        [value]="searchTerm()"
        (input)="updateSearch($event)"
      />
      @if (searchTerm()) {
        <button
          class="clear-search"
          type="button"
          aria-label="Clear search"
          (click)="clearSearch()"
        >
          &times;
        </button>
      }
    </label>
    <a class="new-demand" routerLink="/new">New Demand</a>
  </div>

  <div class="table-scroll">
    <table>
      <caption class="visually-hidden">{{ pageTitle() }}</caption>
      <colgroup>
        <col [style.width.px]="columnWidths().applicationName" />
        <col [style.width.px]="columnWidths().assignedTo" />
        <col [style.width.px]="columnWidths().decomState" />
        <col [style.width.px]="columnWidths().archivalRequired" />
        <col [style.width.px]="columnWidths().archiveAssessment" />
        <col [style.width.px]="columnWidths().archiveState" />
        <col [style.width.px]="columnWidths().intakeCompletionDate" />
      </colgroup>
      <thead>
        <tr>
          <th scope="col" [attr.aria-sort]="ariaSortFor('applicationName')">
            <button type="button" class="sort-header" (click)="sortBy('applicationName')">
              Application Name
              <img src="assets/demands/sort.svg" alt="" [class.sort-icon-ascending]="isSortAscending('applicationName')" />
            </button>
            <button type="button" class="column-resizer"
              aria-label="Resize Application Name column. Use left or right arrow keys; Home sets the minimum width."
              (pointerdown)="startColumnResize($event, 'applicationName')"
              (pointermove)="moveColumnResize($event)" (pointerup)="endColumnResize()"
              (pointercancel)="endColumnResize()" (lostpointercapture)="endColumnResize()"
              (keydown)="resizeColumnWithKeyboard($event, 'applicationName')"></button>
          </th>
          <th scope="col" [attr.aria-sort]="ariaSortFor('assignedTo')">
            <button type="button" class="sort-header" (click)="sortBy('assignedTo')">
              Assigned To
              <img src="assets/demands/sort.svg" alt="" [class.sort-icon-ascending]="isSortAscending('assignedTo')" />
            </button>
            <button type="button" class="column-resizer"
              aria-label="Resize Assigned To column. Use left or right arrow keys; Home sets the minimum width."
              (pointerdown)="startColumnResize($event, 'assignedTo')"
              (pointermove)="moveColumnResize($event)" (pointerup)="endColumnResize()"
              (pointercancel)="endColumnResize()" (lostpointercapture)="endColumnResize()"
              (keydown)="resizeColumnWithKeyboard($event, 'assignedTo')"></button>
          </th>
          <th scope="col">
            Decom State
            <button type="button" class="column-resizer"
              aria-label="Resize Decom State column. Use left or right arrow keys; Home sets the minimum width."
              (pointerdown)="startColumnResize($event, 'decomState')"
              (pointermove)="moveColumnResize($event)" (pointerup)="endColumnResize()"
              (pointercancel)="endColumnResize()" (lostpointercapture)="endColumnResize()"
              (keydown)="resizeColumnWithKeyboard($event, 'decomState')"></button>
          </th>
          <th scope="col" [attr.aria-sort]="ariaSortFor('archivalRequired')">
            <button type="button" class="sort-header" (click)="sortBy('archivalRequired')">
              App Archival required
              <img src="assets/demands/sort.svg" alt="" [class.sort-icon-ascending]="isSortAscending('archivalRequired')" />
            </button>
            <button type="button" class="column-resizer"
              aria-label="Resize App Archival required column. Use left or right arrow keys; Home sets the minimum width."
              (pointerdown)="startColumnResize($event, 'archivalRequired')"
              (pointermove)="moveColumnResize($event)" (pointerup)="endColumnResize()"
              (pointercancel)="endColumnResize()" (lostpointercapture)="endColumnResize()"
              (keydown)="resizeColumnWithKeyboard($event, 'archivalRequired')"></button>
          </th>
          <th scope="col">
            Archive Assessment
            <button type="button" class="column-resizer"
              aria-label="Resize Archive Assessment column. Use left or right arrow keys; Home sets the minimum width."
              (pointerdown)="startColumnResize($event, 'archiveAssessment')"
              (pointermove)="moveColumnResize($event)" (pointerup)="endColumnResize()"
              (pointercancel)="endColumnResize()" (lostpointercapture)="endColumnResize()"
              (keydown)="resizeColumnWithKeyboard($event, 'archiveAssessment')"></button>
          </th>
          <th scope="col">
            Archive State
            <button type="button" class="column-resizer"
              aria-label="Resize Archive State column. Use left or right arrow keys; Home sets the minimum width."
              (pointerdown)="startColumnResize($event, 'archiveState')"
              (pointermove)="moveColumnResize($event)" (pointerup)="endColumnResize()"
              (pointercancel)="endColumnResize()" (lostpointercapture)="endColumnResize()"
              (keydown)="resizeColumnWithKeyboard($event, 'archiveState')"></button>
          </th>
          <th scope="col">
            Submission Date
            <button type="button" class="column-resizer"
              aria-label="Resize Submission Date column. Use left or right arrow keys; Home sets the minimum width."
              (pointerdown)="startColumnResize($event, 'intakeCompletionDate')"
              (pointermove)="moveColumnResize($event)" (pointerup)="endColumnResize()"
              (pointercancel)="endColumnResize()" (lostpointercapture)="endColumnResize()"
              (keydown)="resizeColumnWithKeyboard($event, 'intakeCompletionDate')"></button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="empty-state">
          <td colspan="7">
            No demands yet. Create a new demand to begin an application decommissioning or data archival request.
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="panel-footer" aria-hidden="true"></div>
</section>
